import { render, staticRenderFns } from "./OptionComp.vue?vue&type=template&id=345204fc&scoped=true&"
import script from "./OptionComp.vue?vue&type=script&lang=ts&"
export * from "./OptionComp.vue?vue&type=script&lang=ts&"
import style0 from "./OptionComp.vue?vue&type=style&index=0&id=345204fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345204fc",
  null
  
)

export default component.exports